import { render, staticRenderFns } from "./keynotes.vue?vue&type=template&id=5402e6b6&scoped=true"
import script from "./keynotes.vue?vue&type=script&lang=js"
export * from "./keynotes.vue?vue&type=script&lang=js"
import style0 from "./keynotes.vue?vue&type=style&index=0&id=5402e6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5402e6b6",
  null
  
)

export default component.exports